import { useEffect, useState } from 'react';
import { Page, Section, PaddedContent, Header, Input, icons, Button, Loading } from 'daymap-library';
import Logo from '../../components/Logo/Logo';
import { useNavigate } from 'react-router-dom';

import styles from './Home.module.scss';
import { useApp } from '../../helpers/appContext';
import { useAuth } from '../../helpers/authContext';
import Settings from '../Settings/Settings';

function Home() {
  const { setMode, appType, setAppType, initialRedirectDone, setInitialRedirectDone } = useApp();
  const { settings, clientSettings, signOut } = useAuth();
  const [radioValues, setRadioValues] = useState({ 
    CheckIn: '', 
    Kiosk: '', 
    Visitors: '' ,
    ScheduledEvents: '',
    RoomId: '',
    Room: ''
  });
  const [eventsText, setEventsText] = useState('');
  const navigate = useNavigate();
  const [settingsOpen, setSettingsOpen] = useState(false);
  const [appOptions, setAppOptions] = useState([]);
  const [scheduledCalendars, setScheduledCalendars] = useState(null);
  const [kioskRooms, setRooms] = useState(null);
  const { lmsFetch } = useAuth();


  const getScheduledCalendars = async () => {
    const [getCalendars] = lmsFetch(`/lms/api/checkin/scheduledCalendars`);
    const response = await getCalendars();

    let calendars = response.data?.map(c => {
      return {value: c.CalendarID, text: c.Name}
      });
    let startCheckInMode = clientSettings.defaultCheckInMode || (settings.CheckInModes.length > 0 ? settings.CheckInModes[0] : null);
    let startKioskMode = clientSettings.defaultKioskMode || (settings.KioskModes.length > 0 ? settings.KioskModes[0] : null);
    let startVisitorLocation = clientSettings.defaultVisitorLocation || (settings.VisitorLocations?.length > 0 ? settings.VisitorLocations[0] : null);
    let startScheduledEventMode =  clientSettings.defaultScheduledEventMode ? JSON.parse(clientSettings.defaultScheduledEventMode) : null || (calendars?.length > 0 ? calendars[0] : null);
    let startRoomMode = clientSettings.defaultRoomMode ? JSON.parse(clientSettings.defaultRoomMode) : null || (settings.RoomModes.length > 0 ? settings.RoomModes[0] : null);

    setRadioValues({
      CheckIn: startCheckInMode,
      Kiosk: startKioskMode,
      Visitors: startVisitorLocation,
      ScheduledEvents: startScheduledEventMode?.value,
      RoomId: startRoomMode?.Key,
      Room: startRoomMode?.Value
    });

    if (calendars?.length > 0) {
      setEventsText(startScheduledEventMode.text);
      setScheduledCalendars(calendars);
    }
    else {
      setScheduledCalendars([]);
    }
  }

  const getRooms = () => {
    let rooms = settings.RoomModes.map(r => {
      return {value: r.Key, text: r.Value} // RoomModes ~ KVP of (RoomId, RoomName)
    });

    setRooms(rooms);
  }

  useEffect(() => {
    if(scheduledCalendars == null) { return; }
    const options = [];
    if (settings.CheckInEnabled && settings.CheckInModes?.length > 0)
      options.push({ value: 'Check In', text: 'Check In', iconClass: icons.ICON_CSS_CLASS.SignIn });
    if (settings.KioskModes?.length > 0)
      options.push({ value: 'Kiosk', text: 'Kiosk', iconClass: icons.ICON_CSS_CLASS.Kiosk });

    options.push({ value: 'Visitors', text: 'Visitors', iconClass: icons.ICON_CSS_CLASS.Visitor });
    scheduledCalendars?.length > 0 && options.push({ value: 'Scheduled Events', text: 'Scheduled Events', iconClass: icons.ICON_CSS_CLASS.Class });

    if (settings.RoomModes.length > 0)
      options.push({ value: 'Room', text: 'Room', iconClass: icons.ICON_CSS_CLASS.Room });

    let defaultAppType = clientSettings.defaultAppType;
    if (!options.some(o => o.value === defaultAppType))
      defaultAppType = options[0].value;

    setAppOptions(options);
    setAppType(defaultAppType);

  }, [settings, scheduledCalendars]);

  useEffect(() => {
    getScheduledCalendars();
    getRooms();
  }, [settings]);

  useEffect(() => {
    if (!initialRedirectDone && appType) {
      if (clientSettings.openDefaultOnStart) {
        goClicked();
      }
    }
  }, [appType])


  const radioValuesChanged = (app, sender) => {
    const newRadioValues = { ...radioValues};
    newRadioValues[app] = sender.value;

    if(app === "ScheduledEvents"){
      setEventsText(sender.text);
    }
    else if(app === "RoomId"){
      newRadioValues["Room"] = sender.options[sender.selectedIndex].text;
    }
    setRadioValues(newRadioValues);
  }

  const menuItemClicked = (item) => {
    switch (item.text) {
      case 'Sign Out':
        signOut();
        break;
      case 'Settings': {
        setSettingsOpen(true);
        break;
      }
    }
  }

  useEffect(() => {
    //Only when first loading (for actions on page refresh)
    setMode(null);
    setAppType(null);
    return;
  },[])

  const goClicked = () => {
    setInitialRedirectDone(true); 

    let navTo;
    let mode;
    switch (appType) {
      case 'Check In': {
        mode = radioValues.CheckIn;
        navTo = '/checkin';
        break;
      }
      case 'Kiosk': {
        mode = radioValues.Kiosk;
        navTo = '/kiosk';
        break;
      }
      case 'Visitors': {
        navTo = '/visitors';
        mode = radioValues.Visitors;
        break;
      }
      case 'Scheduled Events': {
        navTo =`/events/${radioValues.ScheduledEvents}`
        mode = eventsText;
        break;
      }
      case 'Room': {
        navTo =`/room/${radioValues.RoomId}`
        mode = radioValues.Room;
        break;
      }
      default: {}
    }
    setMode(mode);
    if (navTo)
      navigate(navTo);
  }

  const menus = [
    { id: 1, text: 'Sign Out', iconCode: icons.ICON_CSS_CLASS.SignOut },
    { id: 2, text: 'Settings', iconCode: icons.ICON_CSS_CLASS.Settings},
  ]

  if (settings == null)
    return <Loading message="Loading Settings" />
  
  return (
    <>
      {settingsOpen && <Settings ScheduledCalenders={scheduledCalendars} onClose={() => setSettingsOpen(false)} />}
      <Page hasHeader center>
        <Header title={<Logo/>} menus={menus} onMenuItemClick={menuItemClicked}/>
        <Section>
          <PaddedContent>
            <div className={styles.Layout}>
              <div>
                <Input 
                  elementType="switchmulti"
                  id="mode"
                  value={appType}
                  config={{options: appOptions}} 
                  onChange={(e) => setAppType(e.target.value)}/>
              </div>
              {appType === 'Check In' &&
                <Input elementType="radiolist" id="checkinmode" config={{options: settings.CheckInModes}} onChange={e => radioValuesChanged('CheckIn', e.target)} value={radioValues.CheckIn} />
              }
              {appType === 'Kiosk' &&
                <Input elementType="radiolist" id="kioskmode" config={{options: settings.KioskModes}} onChange={e => radioValuesChanged('Kiosk', e.target)} value={radioValues.Kiosk} />
              }
              {appType === 'Visitors' &&
                <Input elementType="radiolist" id="visitorlocation" config={{options: settings.VisitorLocations}} onChange={e => radioValuesChanged('Visitors', e.target)} value={radioValues.Visitors} />
              }
              {appType ==='Scheduled Events' &&
              <Input elementType='radiolist' id='scheduledEventCalendar' config={{options: scheduledCalendars}} onChange={e => radioValuesChanged('ScheduledEvents', e.target)} value={radioValues.ScheduledEvents}></Input>
              }
              {appType ==='Room' &&
              <Input elementType='select' id='roommode' config={{options: kioskRooms}} onChange={e => radioValuesChanged('RoomId', e.target)} value={radioValues.RoomId}></Input>
              }

              <Button text="Go" large iconClass={icons.ICON_CSS_CLASS.Play} onClick={goClicked} />
            </div>
          </PaddedContent>
        </Section>
      </Page>    
    </>
  )
}

export default Home;